<template>
  <q-dialog ref="docModal" maximized >
            <q-layout view="Lhh lpR fff" container class="bg-white">
                <q-header>
                    <q-toolbar>
                        <q-toolbar-title>{{ $gettext('VIEW_DOCUMENT') }}</q-toolbar-title>
                          <q-btn data-testid="save-btn" flat @click="btDownload">
                            <q-icon name="get_app" />
                          </q-btn>
                        <q-btn flat @click="closeModal">
                            <q-icon name="close" />
                        </q-btn>
                    </q-toolbar>
                </q-header>
                <q-page-container>
                    <q-page padding>
                        <div v-if="extension === extensions.pdf">
                            <pdf
                                v-for="page in numPages"
                                ref="pdfViewer"
                                :key="page"
                                :page="page"
                                :src="source"
                                :v-if="source"
                                class="full-height full-width"
                                @num-pages="pageCount = $event"
                                @page-loaded="currentPage = $event"
                            />
                        </div>
                        <img v-else-if="extension === extensions.jpg || extension === extensions.png || extension === extensions.jpeg" :src="source">
                    </q-page>
                </q-page-container>
            </q-layout>
        </q-dialog>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import pdf from 'vue-pdf'

@Component({
  name: 'RepresentativeFileModal',
  components: {
    pdf
  },
  props: {
    buttonName: String,
    params: Object,
    nmIdentificacaoParserFile: { type: String, required: true }
  }
})
class FileViewerModal {
  currentPage = 0
  extensions = { pdf: 'pdf', jpg: 'jpg', png: 'png', jpeg: 'jpeg' }
  pageCount = 0
  numPages = 0
  source = ''
  extension = ''
  mounted () {
    if (this.buttonName === 'icDownload') {
      this.btDownload()
    } else if (this.buttonName === 'icDetalharArquivo') {
      this.showDocument()
    }
  }

  closeModal () {
    this.$emit('close-modal', {})
  }

  async btDownload () {
    const file = await repository.downloadFile(
      this.params.name,
      null,
      this.nmIdentificacaoParserFile
    )
    const link = document.createElement('a')
    link.download = this.params.name
    link.href = URL.createObjectURL(file)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    this.closeModal()
  }

  async showDocument () {
    this.extension = this.params.name.split('.')[1]

    const file = await repository.downloadFile(
      this.params.name,
      null,
      this.nmIdentificacaoParserFile
    )
    const link = document.createElement('a')

    const src = URL.createObjectURL(file)
    if (this.extension === this.extensions.pdf) {
      this.source = pdf.createLoadingTask(src)
      if (this.source.promise.then) {
        this.source.promise.then(p => {
          this.numPages = p.numPages
        })
      } else {
        this.numPages = 1
      }
    } else {
      this.source = src
    }
    this.$refs.docModal.show()
  }
}

export default FileViewerModal
</script>

<style>

</style>
